<template>
    <div class="page ethanks">
        <div class="topSec container  min-h-100 d-flex flex-column pt-5">
            <div class="row pt-5">
                <div class="col-12">
                    <div class="h1">
                        Your purchase is complete!
                    </div>
                    <p v-if="$route.query.wallet">
                        You’ve successfully loaded your Kettleman’s Card Wallet and your funds are ready for use in ordering online or in-store.
                    </p>
                    <p v-else>
                        Your gift cards are on their way. The recipient will receive an email notification.
                    </p>
                </div>
            </div>
            <div class="row mt-auto">
                <div class="col-12">
                    <router-link :to="{name:'Home'}" class="btnlink zbg inv">
                        back to home
                    </router-link>
                </div>
            </div>
        
        </div>
    </div>
</template>

<script>
    export default {
        name: "EgiftThanks",
        created() {
            let title = '';
            if(this.$route.query.wallet){
                title = "Send in My Wallet"
            }else{
                title = "Send an E-Gift";
            }
            this.$store.commit("shared/setTopBar", {title: title, showBackButton: false, showBag: false}, {root: true});
        }
    }
</script>
